/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Icon5IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Icon5Icon(props: Icon5IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      viewBox={"0 0 24 24"}
      fill={"none"}
      xmlns={"http://www.w3.org/2000/svg"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M14.316 2.802h-2.45v1.504h1.684V7.14a4.445 4.445 0 01-.333 1.743 4.507 4.507 0 01-.992 1.483 4.599 4.599 0 01-1.497.992 4.665 4.665 0 01-3.542 0 4.6 4.6 0 01-1.497-.992 4.507 4.507 0 01-.992-1.483 4.443 4.443 0 01-.333-1.743V4.306h1.633V2.802H3.598a.777.777 0 00-.542.22.751.751 0 00-.224.532V7.14a5.925 5.925 0 00.448 2.322 6.01 6.01 0 001.323 1.973 6.13 6.13 0 001.995 1.32 6.22 6.22 0 004.717 0 6.13 6.13 0 001.995-1.32 6.009 6.009 0 001.323-1.973 5.924 5.924 0 00.448-2.322V3.554c0-.2-.08-.39-.224-.531a.773.773 0 00-.54-.22z"
        }
        fill={"currentColor"}
      ></path>

      <path
        d={
          "M17.567 13.171v3.564c0 2.802-2.516 3.757-4.627 3.757a3.867 3.867 0 01-2.702-1.102 3.732 3.732 0 01-1.123-2.655V11.82H7.584v4.915a5.225 5.225 0 001.571 3.721A5.414 5.414 0 0012.943 22c2.955 0 6.159-1.67 6.159-5.265V13.17h-1.535z"
        }
        fill={"currentColor"}
      ></path>

      <path
        d={
          "M18.333 8.64c-.56 0-1.11.163-1.575.469-.467.306-.83.741-1.045 1.25a2.74 2.74 0 00-.161 1.61c.11.54.38 1.037.776 1.426.396.39.902.655 1.452.763.55.107 1.12.052 1.638-.159.518-.21.961-.568 1.273-1.026a2.751 2.751 0 00-.353-3.518 2.861 2.861 0 00-2.005-.816zM5.971 2a.773.773 0 00-.541.22.746.746 0 00-.224.532v1.605c0 .2.08.39.224.532a.773.773 0 001.083 0 .746.746 0 00.224-.532V2.752c0-.2-.08-.39-.224-.532A.773.773 0 005.97 2zm5.653 0a.778.778 0 00-.541.22.752.752 0 00-.225.532v1.605c0 .2.081.39.225.532a.772.772 0 001.082 0 .746.746 0 00.225-.532V2.752c0-.2-.08-.39-.225-.532a.773.773 0 00-.54-.22z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  );
}

export default Icon5Icon;
/* prettier-ignore-end */
